/** Internal helper imports here ... */
import { forEach, find } from 'lodash';
import DomHelper from '../helpers/DomHelper';
import Media from '../helpers/matchMediaGenerator';

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
export default (() => {
  /**
   * Other functions...
   */

  const init = () => {
    const boxContainers = document.querySelectorAll('.DroversBoxImageLinks');
    const accordionSections = document.querySelectorAll('.AccordionSection');

    forEach(boxContainers, (boxContainer) => {
      const boxes = boxContainer.querySelectorAll('.accordionSectionTrigger');

      forEach(boxes, (box) => {
        const accordionNumber = box.attributes['data-accordion-number'].value;

        box.addEventListener('click', () => {
          if (!box.classList.contains('active')) {
            const accordion = find(accordionSections, accordionSection => accordionSection.attributes['data-accordion-number'].value === accordionNumber);

            const accordionPosition = accordionSections[0].getBoundingClientRect();
            const bodyPosition = document.body.getBoundingClientRect();

            const accordionHeight = DomHelper.getNodeActualHeight(accordion);

            forEach(boxes, (singleBox) => {
              singleBox.classList.remove('active');
            });

            box.classList.add('active');

            forEach(accordionSections, (accordionSection) => {
              accordionSection.classList.remove('active');
              accordionSection.removeAttribute('style');
            });

            setTimeout(() => {
              accordion.setAttribute('style', `height: ${accordionHeight}px`);
              if (Media.getMedia([false, 768]).matches) {
                window.scrollTo({
                  top: accordionPosition.top - bodyPosition.top,
                  behavior: 'smooth'
                });
              }
            }, 1);
          } else {
            forEach(boxes, (singleBox) => {
              singleBox.classList.remove('active');
            });

            forEach(accordionSections, (accordionSection) => {
              accordionSection.classList.remove('active');
              accordionSection.removeAttribute('style');
            });
          }
        });
      });
    });
  };

  return {
    init,
  };
})();
